import React, { useEffect, useState } from 'react'
import { Button, Grid, Typography } from '@material-ui/core'
import ListSelector from '../../commons/ListSelector'
import ImportExportIcon from '@material-ui/icons/ImportExport'
import { getFromApi, postToApi } from 'actions'
import utils from 'utils/utils'
import Spinner from '../../commons/Spinner'
import { useStateValue } from 'context/store'
import { useHasOperation } from 'hooks/useHasOperation'
import { OPERACIONES_ROLES } from 'utils/constants'

const RoleExport = () => {
   const style = {
      title: {
         fontSize: 16,
         fontWeight: 700
      },
      container: {
         margin: '10px 0px 10px 10px',
         paddingRight: '20px'
      },
      circleIcon: {
         borderRadius: '50%',
         backgroundColor: '#4e537329',
         margin: 5,
         paddingTop: 5
      }
   }

   const exportPayloadInitialData = {
      applicationsIds: [],
      roleIds: [],
      exportRoles: true
   }

   const [rolesList, setRolesList] = useState([])
   const [applicationsList, setApplicationsList] = useState([])
   const [rolesSelected, setRolesSelected] = useState([])
   const [applicationSelected, setApplicationSelected] = useState([])
   const [key, setKey] = useState(0)
   const [keyRol, setKeyRol] = useState(0)
   const [loading, setLoading] = useState(false)
   const [exportPayload, setExportPayload] = useState(exportPayloadInitialData)
   const [, dispatch] = useStateValue()
   const EXPORTAR_ROL = useHasOperation(OPERACIONES_ROLES.EXPORTAR)

   useEffect(() => {
      getApplicationList()
   }, [])

   useEffect(() => {
      setExportPayload({
         applicationsIds: applicationSelected,
         roleIds: rolesSelected,
         exportRoles: true
      })
   }, [rolesSelected, applicationSelected])

   const roleSelectedCallback = roles => {
      const roleSelected = []
      roles.forEach(rolSelected => {
         rolesList.forEach(rol => {
            if (rol.id == rolSelected) {
               roleSelected.push(rol.code)
            }
         })
      })
      setRolesSelected(roleSelected)
   }

   const getApplicationList = async () => {
      setLoading(true)
      let response = await getFromApi(
         `${process.env.REACT_APP_AUTHORIZATION_API}/user/applications`
      )
      response = utils.sortObjectByPropName(response, 'name')
      response = response.map(appData => ({
         id: appData.code,
         ...appData
      }))
      setApplicationsList(response)
      setLoading(false)
   }

   const getRoleList = async idsApplication => {
      let response = await getFromApi(
         `${process.env.REACT_APP_AUTHORIZATION_API}/user/applications/roles?${idsApplication}`
      )
      response = utils.sortObjectByPropName(response, 'name')
      response = response.map(rolData => ({
         id: rolData.code,
         ...rolData
      }))
      setRolesList(response)
   }

   const applicationSelectedCallback = application => {
      setApplicationSelected(application)
      let appsIdString = ''
      application.forEach(appId => {
         appsIdString += `applicationCodes=${appId}&`
      })
      appsIdString =
         appsIdString.slice(-1) === '&'
            ? appsIdString.slice(0, appsIdString.length - 1)
            : appsIdString

      if (appsIdString.length) {
         getRoleList(appsIdString)
      } else {
         setRolesList([])
      }

      setKeyRol(oldKey => oldKey + 1)
   }

   const handleSave = async () => {
      setLoading(true)
      await postToApi(
         `${process.env.REACT_APP_AUTHORIZATION_API}/config/export`,
         exportPayload
      )
         .then(async response => {
            await utils.downloadJSON(response, `roles_${Date.now()}.json`)
         })
         .catch(error => {
            dispatch({
               type: 'OPEN_SNACKBAR',
               openMessage: {
                  open: true,
                  message:
                     error?.message ||
                     'Lo sentimos, ha ocurrido un error exportando el rol'
               }
            })
         })
      setLoading(false)
   }

   const handleClean = () => {
      setKey(oldKey => oldKey + 1)
      setKeyRol(oldKey => oldKey + 1)
   }

   return (
      <div>
         <Spinner open={loading} />
         <Grid container style={style.container} justify="flex-end">
            <Grid item xs={12} className="mb10">
               <Typography style={style.title} variant="h6">
                  <span style={style.circleIcon}>
                     <ImportExportIcon fontSize="small" style={{ width: 26 }} />
                  </span>
                  Exportar Roles
               </Typography>
            </Grid>
            <Grid item xs={12} sm={6} lg={6} xl={6}>
               <ListSelector
                  key={key}
                  title={'Aplicaciones'}
                  listItem={applicationsList}
                  listSelectionCallback={applicationSelectedCallback}
               />
            </Grid>
            <Grid item xs={12} sm={6} lg={6} xl={6}>
               <ListSelector
                  key={keyRol}
                  title={'Rol'}
                  listItem={rolesList}
                  listSelectionCallback={roleSelectedCallback}
               />
            </Grid>
         </Grid>
         <Grid
            container
            direction="row"
            justify="flex-end"
            style={style.container}
         >
            <Grid>
               <Button variant="outlined" color="primary" onClick={handleClean}>
                  LIMPIAR
               </Button>
            </Grid>
            <Grid style={{ marginLeft: 20 }}>
               <Button
                  variant="contained"
                  color="primary"
                  disabled={!rolesSelected.length || !EXPORTAR_ROL}
                  onClick={handleSave}
               >
                  GUARDAR
               </Button>
            </Grid>
         </Grid>
      </div>
   )
}

export default RoleExport
